<template>
  <footer class="footer">
    <div class="footer__copyright" v-text="ui.copyright" />
    <!--
    <div class="footer__created">
      <span v-text="createdBy+ ' '" />
      <a href="http://imagine.lt" target="_blank">IMAGINE</a>
    </div>
    -->
  </footer>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ifDefined from '@/tools/ifDefined'

export default {
  name: 'PageFooter',
  computed: {
    ...mapGetters(['ui']),
    createdBy() {
      return ifDefined(this.ui.created_by) ? this.ui.created_by : ''
    }
  },
  methods: {
    ...mapActions([])
  }
}
</script>



// WEBPACK FOOTER //
// src/partials/PageFooter.vue